<template>
    <b-card no-body>
        <b-card-body>
            <b-card bg-variant="light">
                <b-form @submit.prevent="load">
                    <b-form-row class="align-items-center">
                        <b-col cols="2">
                            <lg-form-const-select label="Situação:" v-model="form.situacao" @change="load()"
                                :options="form.optionsFilterSituacao" />
                        </b-col>

                        <b-col cols="3">
                            <lg-form-input v-model="form.descricao" label="Descrição:" description=" " />
                        </b-col>
                        <b-col cols="4" class="text-right">
                            <b-button :id="`localizar-tipo-empenho`" class="ml-3 mr-2 my-2" size="sm"
                                style="height: 20px" pill variant="primary" @click="load">
                                <div class="btn-size-alinhamento">
                                    <b-icon icon="search" />
                                </div>
                                <b-tooltip :target="`localizar-tipo-empenho`" title="Localizar"></b-tooltip>
                            </b-button>
                            <b-button v-if="temPrivilegioCriacao()" id="novo-tipo-empenho" class="mr-2 my-2" size="sm"
                                style="height: 20px" pill @click="ModalAdicionar" variant="primary">
                                <div class="btn-size-alinhamento">
                                    <b-icon scale="1" icon="plus" />
                                </div>
                                <b-tooltip :target="`novo-tipo-empenho`" title="Adicionar novo..."></b-tooltip>
                            </b-button>
                        </b-col>
                    </b-form-row>
                </b-form>
                <b-table responsive class="mt-2" small :busy="this.busy" :items="this.records"
                    :fields="this.tableFields" :hover="true" @row-dblclicked="onDblClickTipoEmpenhoSelect" show-empty>
                    <template #empty>
                        <p>Nenhum registro encontrado</p>
                    </template>

                    <template #table-busy>
                        <div class="text-center text-primary my-2">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                    </template>
                    <template v-slot:cell(acoes)="{ item }">
                        <div class="d-flex align-items-center">
                            <b-form-checkbox v-if="temPrivilegioEdicao()" v-model="item.situacao"
                                @change="alteraSituacao(item)" name="check-button" switch size="lg" :value="1"
                                :unchecked-value="0" class="mr-2" />

                            <b-button id="modificar" class="my-2 text-right" size="sm" pill variant="primary"
                                @click="ModalEditar(item)" v-if="temPrivilegioEdicao()">
                                <b-icon icon="pencil-square" />
                                <b-tooltip target="modificar" title="Editar..." triggers="hover"></b-tooltip>
                            </b-button>
                        </div>
                    </template>
                    <template v-slot:cell(action)="{ item }">
                        <lg-button-acoes-icons :actions="actionsBtn" :itemRecord="item"></lg-button-acoes-icons>
                    </template>
                </b-table>
                <b-row style="margin-top: 12px" v-if="records && records.length > 0">
                    <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">
                        <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Página {{ page }} de
                            {{
                            totalPage }} -
                            {{ total }} registros</b-col>
                        <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Mostrando:&nbsp;
                            <b-form-select size="sm" v-model="perPage" @change="() => this.load()"
                                :options="perPageOptions">
                            </b-form-select>
                        </b-col>
                    </b-col>
                    <b-col cols="6">
                        <div class="d-flex justify-content-end align-items-end">
                            <b-pagination style="margin-bottom: 10px; margin-top: 10px" v-model="page"
                                :per-page="perPage" :total-rows="total"></b-pagination>
                        </div>
                    </b-col>
                </b-row>
                <TipoEmpenhoForm v-if="showModalAdicionar" :prefix="updatedPrefix" @close="fechar" :id="idEdit" />
            </b-card>
        </b-card-body>
    </b-card>
</template>

<script>
import ResourceService from "@/core/api/ResourceService";
import LgButtonAcoesIcons from "@/core/components/Form/LgButtonAcoesIcons.vue";
import LgFormConstSelect from "@/core/components/Form/LgFormConstSelect.vue";
import LgFormInput from "@/core/components/Form/LgFormInput.vue";
import { ListResourceMixin } from "@/core/mixins/resource";
import TipoEmpenhoForm from "./TipoEmpenhoForm.vue";
import ConfirmMixin from "@/core/mixins/confirm";
import verificaPrivilegio from "@/utils/VerificaPrivilegio"
import PrivilegiosEnum from "@/core/utils/PrivilegioEnum"


export default {
    components: {
        LgFormInput,
        LgFormConstSelect,
        LgButtonAcoesIcons,
        TipoEmpenhoForm,
    },
    props: {
        codEmpresa: Number,
        prefix: {
            Array,
            default: () => [],

        },
    },
    data() {
        return {
            showModalAdicionar: false,
            idEdit: null,
            perPage: 10,
            perPageOptions: [10, 25, 50, 100],
            filtro: "",
            form: {
                descricao: "",
                situacao: 1,
                optionsFilterSituacao: [
                    { key: "filterSituacao", text: "Todos", value: undefined },
                    { key: "filterSituacao", text: "Ativo", value: 1 },
                    { key: "filterSituacao", text: "Inativo", value: 0 },
                ],
            },
        };
    },
    mixins: [ListResourceMixin, ConfirmMixin],
    beforeMount() {
        this.$service = new ResourceService(`/api/tiposempenho`);
    },
    mounted() {
        this.load();
    },

    watch: {
        page() {
            this.load();
        },
    },
    computed: {

        updatedPrefix() {
            return [...this.prefix];
        },
        title() {
            return this.updatedPrefix.join(" > ");
        },
        tableFields() {
            return [
                { key: "descricao", label: "Descrição" },
                { key: "acoes", label: "", tdClass: "w-1" },
            ];
        },
    },
    methods: {


        temPrivilegioEdicao() {
            return verificaPrivilegio(PrivilegiosEnum.CAD_ESSENC_ALMOXARIFADO_EDITAR);

        },


        temPrivilegioCriacao() {
            return verificaPrivilegio(PrivilegiosEnum.CAD_ESSENC_ALMOXARIFADO_INCLUIR);

        },

        async alteraSituacao(item) {
            let response;

            if (item.situacao == 1) {
                response = await this.$confirm(
                    `Deseja ativar o registro ${item.descricao}?`
                );
            }
            if (item.situacao == 0) {
                response = await this.$confirm(
                    `Deseja desativar o registro ${item.descricao}?`
                );
            }

            if (response === true) {
                this.confirmarAlteracaoSituacao(item);
            } else {
                item.situacao = item.situacao == 1 ? 0 : 1;
            }
        },
        async confirmarAlteracaoSituacao(item) {
            const { status } = await this.$service.alteraSituacao(item);

            if (status == 200) {
                this.$notify({
                    type: "success",
                    message: `Registro ${item.situacao ? "Ativado" : "Desativado"
                        } com sucesso!`,
                });
            } else {
                this.$notify({
                    type: "danger",
                    message: `Erro ao ${item.situacao ? "Ativar" : "Desativar"
                        } o registro!`,
                });
            }
        },
        ModalAdicionar() {
            this.showModalAdicionar = true;

        },
        ModalEditar(item) {
            this.idEdit = item.id;
            this.showModalAdicionar = true;
        },
        fechar() {
            this.showModalAdicionar = false;
            this.idEdit = null;
            this.load();
        },
        async load() {
            this.filtro = {};
            if (this.form.descricao) {
                this.filtro.descricao + this.form.descricao;
            }
            if (this.form.situacao != null) {
                this.filtro.situacao = this.form.situacao;
            }
            this.busy = true;
            await this.$loadResource({
                size: this.perPage,
                page: this.page,
                params: this.filtro,
            });
        },
        async onDblClickTipoEmpenhoSelect(item) {
            this.$emit("onDblClickTipoEmpenhoSelect", item);
        },
    },
};
</script>
